// @flow
import React, { useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';

import { Addition, type AdditionItemProps } from 'Components/frameworks/addition/Addition.jsx';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { TextLink } from 'Components/frameworks/text-link/TextLink.jsx';

type AllInclusivePushProps = {
  items: Array<AdditionItemProps>,
};

export function AllInclusivePush(props: AllInclusivePushProps) {
  const { items = [] } = props;

  const { isTablet } = useContext(ResponsiveContext);

  if (!items.length) {
    return null;
  }

  const filteredItems = items.filter(item => item.label || item.icon);
  const { icon: lastIcon = {}, label: lastLabel = '', link: lastLink = {} } =
    filteredItems.pop() || {};

  return isTablet ? (
    <Addition items={items} />
  ) : (
    <ul className="list-none p-0">
      {filteredItems.map(({ label }) => (
        <li className="flex items-center font-bold pb-2 text-base text-gray-darker" key={label}>
          <Icon className="rtl:mr-2" color={COLORS.BLUE} name={ICONS.CHECK} width="1em" />
          {label}
        </li>
      ))}
      <li className="flex flex-col mt-2">
        <Icon color={COLORS.BLUE} isNotSquare name={lastIcon.name} width="40%" />
        {lastIcon.alt && <span className="a11y">{lastIcon.alt} </span>}
        <TextLink className="mt-3 self-end" label={lastLabel} url={lastLink.url} />
      </li>
    </ul>
  );
}
